import React from 'react';
import { compose, is, pipe, map, find } from 'ramda';
import moment from 'moment';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import connect from 'react-redux/es/connect/connect';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './Confirmation.js';
import { RichText, Image, Button, Link } from '@synergycms_core/components/generic';
import Stars from '../../components/functional/Stars';
import { AvailMainSideSummary } from '../../components/functional/AvailMainSideSummary';
import { getPenalties } from '../../utils/penalties';
import { payForms } from '../../config/payforms';
import { fromJS, List, Map } from 'immutable';
import { langCodeCorrector } from '@synergycms_core/utils/api';
import { isRefundable, parseServices, addScripts, reservationAvailQuery, getRoomName } from '../../utils';
import CorporateBanner from '../../components/functional/Confirmation/CorporateBanner';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import storage from '@synergycms_core/utils/storage';
import actions from '../../store/actions';
import { PROPERTY_MANAGEMENT_GROUP } from '../../config/constants';
import format from 'string-template';
import MBoxBanner from '../../components/functional/Confirmation/MBoxBanner.jsx';
import LoyaltyConfirmationInfo from '../../components/functional/Loyalty/LoyaltyConfirmationInfo.jsx'
import { getLoyaltyDiscount } from '../../store/avail/availUtils.js';
import {contextualizeAppConfig} from '@synergycms_core/store/app/utils';
import AmenitiesList from '../../components/functional/AmenitiesList';
import { api } from '@synergycms_core/utils';

const ConfirmationSimple = props => {
  const { classes } = props;
  var fullName =
    props.reservation.getIn(['customer', 'name']) +
    (props.reservation.getIn(['customer', 'surname']) ? ` ${props.reservation.getIn(['customer', 'surname'])}` : '');
  const fullTracking = `${props.reservation.get('hotel_code')}-${props.reservation.get('tracking_id')}`;
  const isCostumerGuest = props.reservation.getIn(['customer', 'guest_booker', 'booker_email'])
  const [guestEmailSendSuccess, setGuestEmailSendSuccess] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);


  function sendGuestEmail() {
    const hotelId = props.hotelId;
    const trackingId = props.reservation.get('tracking_id');
    const pinCode = props.reservation.get('pin_code');

    const extraHeaders = [{ Authorization: 'Basic ' + btoa(trackingId + ':' + pinCode) }];
    return api.get(`cms/send_confirmation_guest/${trackingId}`, {}, hotelId, extraHeaders).then(response => {
      if(response.success) setGuestEmailSendSuccess(true);
      else {
        setGuestEmailSendSuccess(false);
        setErrorMessage(response.message)
      }
    }).catch(error => {
      setGuestEmailSendSuccess(false);
      setErrorMessage('error al enviar')
    })
  }



  return (
    <div className={classes.resumeSimpleContainer}>
      <div className={classes.resumeSimple}>
        <div className={classes.customer}>
          <div className={classes.title}>
            <div>
              <Image innerStyle={classes.bookIcon} svg={'bookIcon'} />
              <RichText translate={true} ucFirst={true} text={'_%tu reserva ya está confirmada%_'} />
              <div>
                <RichText text={fullName} />
              </div>
            </div>
          </div>
          <div className={classes.body}>
            <RichText translate={true} ucFirst={true} text={'_%en breves enviaremos un email a%_'} />{' '}
            <RichText text={props.reservation.getIn(['customer', 'email'])} />{' '}
            <RichText translate={true} ucFirst={false} text={'_%con la confirmación de reserva%_'} />

            {isCostumerGuest && !guestEmailSendSuccess ? (
              <>
                .{' '}
                <RichText
                  translate={true}
                  ucFirst={true}
                  text={'_%si quieres reenviar los detalles de la reserva al email del huésped asociado haz click%_'}
                />
                <Button innerStyle={classes.email} onClick={sendGuestEmail}>
                  <RichText
                    innerStyle={['roboto13BoldBlack']} t
                    translate={true}
                    ucFirst={false}
                    text={'_%aquí%_'}
                  />
                </Button>
                .{' '}


                {errorMessage === 'NO_GUEST_FOUND' && (
                  <>
                    <br />
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%lo sentimos, pero los detalles de la reserva no se han podido reenviar. Por favor inténtalo de nuevo más tarde%_'}
                      innerStyle={classes.bookerSendError}
                    />
                  </>
                )}
                {errorMessage === 'MAX_NUMBER_OF_EMAILS_EXCEEDED' && (
                  <>
                    <br />
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%lo sentimos, pero los detalles de la reserva no se han podido reenviar. Por favor inténtalo de nuevo más tarde%_'}
                      innerStyle={classes.bookerSendError}
                    />
                  </>
                )}
              </>
            ) : (<>.{' '}</>)}

            {guestEmailSendSuccess && (
              <>
                <br />
                <RichText
                  translate={true}
                  ucFirst={true}
                  text={'_%los detalles de la reserva se han reenviado con éxito%_'}
                  innerStyle={['roboto13BoldBlack', classes.bookerSendSucces]}
                />
              </>
            )}

            {!isCostumerGuest &&
              <>
                <RichText
                  translate={true}
                  ucFirst={true}
                  text={'_%si necesitamos contactar contigo lo haremos a través del número de teléfono%_'}
                />{' '}
                {props.phonePrefix !== '' &&
                  <RichText dangerouslySetInnerHTML={'(+' + props.phonePrefix + ')&nbsp;'} />}
                <RichText text={props.reservation.getIn(['customer', 'phone'])} />
              </>
            }
          </div>
        </div>
        <div className={classes.simpleBookingInfo}>
          <ul className={classes.locator}>
            <li className={classes.locatorBox}>
              <RichText translate={true} ucFirst={true} text={'_%localizador%_'} innerStyle={classes.locatorTitle} />
              <RichText text={fullTracking} innerStyle={classes.locatorValue} />
            </li>
            <li className={classes.locatorBox}>
              <RichText
                translate={true}
                ucFirst={true}
                text={'_%pin%_'}
                innerStyle={[classes.locatorTitle, classes.pinTitle].join(' ')}
              />
              <RichText text={props.reservation.get('pin_code')} innerStyle={classes.locatorValue} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const Breakdown = props => {
  const { hotelInfo, reservation, langCode, parsedServices,  reservationRequest, classes } = props;
  const showTaxes = hotelInfo.get('show_taxes');

  const occupancies = {
    10: 0, // Adult
    8: 0, // Child
    childInfo : []
  };
  let allChildsInfo = List();

  const defaultPreferences = hotelInfo.get('preferences').reduce((preferences, p) => {
    return preferences.set(p.get('id'), p.getIn(['options', 0, 'id']));
  }, Map());

  const breakdown = [];

  reservation.get('blocks').forEach(block => {
    const roomId = block.get('room_id').toString();
    const occupGroupId = block.get('occup_group_id');
    const boardId = block.get('board_id').toString();
    const reservationRequestBlock = reservationRequest.getIn(['blocks', block.get('idx') - 1]);

    // Occupancies
    const occupGroup = reservation.get('occup_groups').find(og => {
      return +og.get('id') === +occupGroupId;
    });
    occupGroup.get('occupancies').forEach(occupancy => {
      occupancies[occupancy.get('code')] += occupancy.get('count');
    });

    if(block.get("childs_info")?.size) {
      occupancies[8]+=block.get("babies", 0);
      allChildsInfo = allChildsInfo.merge(block.get("childs_info"));
    }

    const adults = reservationRequestBlock.get('adults');
    const childs = reservationRequestBlock.get('childs');
    const babies = block.get("babies", null);
    const childsInfo = block.get("childs_info", null);
    const totalOccupants = adults + childs;

    // Breakdown (Room + Board + Preferences + Services)
    const room = reservation.get('rooms').find(r => +r.get('id') === +block.get('room_id'));

    const serviceShowAsRoom = block.get('services').reduce((service, s) => {
      const showAsRoom = s.get('restrict_by_room_occup') &&
        s.get('restrictions_room_occup').find(r => r.get('show_as_room'))

      if(showAsRoom)
        service = s;

      return service
    }, Map())



    const serviceIncludedId =  serviceShowAsRoom.size ? serviceShowAsRoom.get('service_id') : null
    let servicePriceIncluded = 0

    if(serviceShowAsRoom.get('service_id', null) && !serviceShowAsRoom.get('has_closed_price', false)){

      servicePriceIncluded = showTaxes ? serviceShowAsRoom.get('price_tax') : serviceShowAsRoom.get('price')
      switch (serviceShowAsRoom.get('type')) {
        case 'person':
        case 'person_night':
          if(serviceShowAsRoom.get('has_price_per_child', false)) {
            servicePriceIncluded = (servicePriceIncluded * adults) + (serviceShowAsRoom.get('child_price_tax') * childs);
          } else {
            const totalOccupants = adults + childs;
            servicePriceIncluded *= totalOccupants;
          }

          break;
        case 'use':
          servicePriceIncluded *= serviceShowAsRoom.get('quantity');
          break;
        default:
          break;
      }
    }


    const sections = reservation.get('sections');
    const roomInfo = sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === occupGroupId && s.get('content_type_service_id') === serviceIncludedId) ||
      sections.find(s => s && +s.get('content_type_id') === +roomId && s.get('content_type_occup_group_id') === room.get('default_occup_group_id') && s.get('content_type_service_id') === serviceIncludedId );
    const roomTranslations = roomInfo && roomInfo.getIn(['translations', langCode]);

    const needAddOccupName = (roomInfo && roomInfo.get('occup_group_id') !== reservationRequestBlock.get('occup_group_id')) || childsInfo;
    let roomOccupName =  getRoomName({childsInfo, adults, childs, babies });

    let roomTitle;
    if (roomTranslations && !childsInfo) {
      roomTitle = roomTranslations.get('title') ? roomTranslations.get('title') : roomTranslations.get('default_title', 'room');
    } else {
      roomTitle = reservation
        .get('rooms')
        .find(s => +s.get('id') === +roomId)
        .getIn(['translations', langCode, 'name'], 'room');
    }

    if (needAddOccupName) {
      roomTitle += roomOccupName;
    }

    const board = reservation
      .get('boards')
      .find(b => +b.get('id') === +boardId)
      .getIn(['translations', langCode]);

    const roomServices =
      parsedServices && parsedServices.size > 0
        ? block.get('services').reduce((services, service) => {
          const serviceId = service.get('service_id');
          const serviceIndex = parsedServices.findIndex(s => s.get('service_id') === serviceId);
          if (serviceIndex !== -1) {
            const serviceData = reservation.get('services').find(s => s.get('id') === serviceId);
            const serviceType = service.get('type');
            const serviceQuantity = service.get('quantity');
            const serviceName = serviceData.getIn(['translations', langCode, 'name']);
            let servicePriceTax = serviceData.get('price_tax');
            const totalOccupants = adults + childs;

            switch (serviceType) {
              case 'person':
              case 'person_night':
                if(service.get('has_price_per_child', false)) {
                  servicePriceTax = (servicePriceTax * adults) + (service.get('child_price_tax') * childs);
                } else {
                  servicePriceTax *= totalOccupants;
                }
                break;
              case 'use':
                servicePriceTax *= serviceQuantity;
                break;
              default:
                break;
            }

            const shouldRenderMessage = false;
            /*(serviceType === 'person' || serviceType === 'person_night') &&
            serviceQuantity < totalOccupants && service.get('works_with_quota', false) && service.get('works_with_quota_time', false);*/

            const parsedReferencedService = parsedServices.find(s => s.get('service_id') === serviceId && block.get('idx') === s.get('blockIdx')) || false;

            if(!service.get('works_with_quota', false) && !service.get('works_with_quota_time', false)){
              services.push({
                name: serviceName,
                price: servicePriceTax,
                quantity: serviceQuantity,
                date: parsedReferencedService ? parsedReferencedService.get('stringDate', '') : false,
                serviceType,
                shouldRenderMessage
              });
            } else {
              parsedServices.forEach(s => {
                if (s.get('service_id') === serviceId && block.get('idx') === s.get('blockIdx')) {
                  services.push({
                    name: serviceName,
                    price: s.get('price'),
                    quantity: s.get('quantity'),
                    date: s.get('stringDate', ''),
                    serviceType,
                    shouldRenderMessage
                  });
                }
              });
            }

          }
          return services;
        }, [])
        : [];

    const roomPreferences = block.get('preferences').reduce((preferences, preference) => {
      const preferenceId = preference.get('preference_id');
      const optionId = preference.get('option_id');
      if (defaultPreferences.get(preferenceId) !== optionId) {
        const roomPreference = reservation.get('preferences').find(p => p.get('id').split('-')[0] === preferenceId);

        preferences.push({
          preference: roomPreference.getIn(['translations', langCode, 'name']),
          option: roomPreference
            .get('options')
            .find(o => o.get('id').split('-')[0] === optionId)
            .getIn(['translations', langCode, 'description'])
        });
      }
      return preferences;
    }, []);

    let boardName = 'board';
    if (board && board.get) {
      const corporate = block.get('is_corporate', false);
      boardName = corporate && board.get('corporate_name') ? board.get('corporate_name') : board.get('custom_name_web') ? board.get('custom_name_web') : board.get('name', 'board');
    }

    const days = block.get('days').reduce((days, day) => {
      const roomDayPrice = showTaxes ? day.get('price_tax') : day.get('price')

      let serviceDayPriceIncluded  = 0
      if(serviceShowAsRoom.size && !serviceShowAsRoom.get('has_closed_price', false)){
        const serviceDayShowAsRoom = serviceShowAsRoom.get('days').find(s => s.day === day.day)
        serviceDayPriceIncluded = showTaxes ? serviceDayShowAsRoom.get('price_tax') : serviceDayShowAsRoom.get('price')
          switch (serviceShowAsRoom.get('type')) {
            case 'person':
            case 'person_night':
              if(serviceShowAsRoom.get('has_price_per_child', false)) {
                serviceDayPriceIncluded = (serviceDayPriceIncluded * adults) + (serviceShowAsRoom.get('child_price_tax') * childs);
              } else {
                const totalOccupants = adults + childs;
                serviceDayPriceIncluded *= totalOccupants;
              }

              break;
            case 'use':
              serviceDayPriceIncluded *= serviceShowAsRoom.get('quantity');
              break;
            default:
              break;
          }

      }

      days.push({
        day: day.get('day').split('-').reverse().join(' / '),
        price: roomDayPrice + serviceDayPriceIncluded
      });
      return days;
    }, []);

    const hasClosedPrice = reservation.get('services').find(service =>
        service.get('has_closed_price') === true
    );

    const price = hasClosedPrice ? (hasClosedPrice.get('price') || hasClosedPrice.get('price_tax') || null) : null;



    breakdown.push({
      room: roomTitle,
      board: boardName,
      price: (showTaxes ? block.get('price_tax') : block.get('price')) + servicePriceIncluded,
      preferences: roomPreferences,
      days: days,
      services: roomServices,
      totalOccupants: totalOccupants,
      closedPrice : price
    });
  });

  return (
    <div className={classes.resumeFullContainer}>
      <div className={classes.resumeFull}>
        <div className={classes.resume}>
          <div className={classes.summary}>
            <AvailMainSideSummary reservationConfirmed={true} innerStyle={'confirmationSummary'}/>
          </div>
        </div>
        <div className={classes.actionsContainer}>
          <div className={classes.actions}>
            <ul className={classes.actionsGrid}>
              <li className={classes.actionContainer}>
                <Button
                  onClick={() => window.print()}
                  innerStyle={classes.actionIconContainer}
                  icon={{
                    unicodeContent: 'e15d',
                    innerStyle: [classes.actionIcon]
                  }}
                  ariaLabel={'_%print%_'}
                  translate={true}
                />
              </li>
              {/*
              <li className={classes.actionContainer}>
                <Button
                  innerStyle={classes.actionIconContainer}
                  icon={{
                    unicodeContent: 'e15e',
                    innerStyle: [classes.actionIcon]
                  }}
                />
              </li>
              */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};


const RoomsInfo = props => {

  const { hotelInfo, reservation, langCode, classes, theme, isMobile, width } = props;
  let resizableImages = theme.resizableImages && width ? width : '';

  const breakdown = [];
  reservation.get('blocks').forEach((block,key) => {
    const section = reservation.getIn(['sections',key]);
    if(!section) return;

    const roomData = hotelInfo.get('rooms').find(function (room) {
      return room.get('id').toString() === block.get('room_id').toString();
    });

    var title = roomData.get('name').toString() || '';
    var description = roomData.get('description').toString() || '';

    if(section && section.get('translations').size > 0) {
      title = section.getIn(['translations', langCode, 'title']) || title;
      description = section.getIn(['translations', langCode, 'description']) || description;
    }

    breakdown.push({
      id: section.get('content_type_id'),
      roomSection: roomData,
      title: title,
      description: description,
      photo: roomData.get('photo').toString() || '',
      photos: roomData.get('photos').toJS() || [],
      amenities: roomData.get('amenities') || [],
      highlighted_amenities: roomData.get('highlighted_amenities') || [],
      travelClubEnabled: hotelInfo.get('travelclub', false),
      services: block.get('services'),
      servicesIds: block.get('services').map(s => s.get('id')),
    });
  });

  // breackdown unique
  const rooms = [];
  breakdown.forEach((room) => {
    const index = rooms.findIndex((r) => r.id === room.id);
    if(index === -1) {
      rooms.push(room);
    }
  });


  return (
    <div className={classes.roomsFullContainer}>
      <div className={classes.roomsFull}>
        {rooms.map((data, idx) => {
          return (
            <div className={classes.roomsResume} key={idx}>
              {!isMobile &&
                <div className={classes.roomsPhotos}>
                  <Image
                    innerStyle={'backgroundImageBase'}
                    src={process.env.NODE_ENV === 'development'
                      ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                      : data.photo + resizableImages}
                    loading={'lazy'}
                    alt={data.title}
                  />
                </div>
              }
              <div className={classes.roomsInfo}>
                <RichText
                  innerStyle={data.travelClubEnabled ? ['avail', 'roomTitle', 'travelClubTextWidth'] : ['avail', 'roomTitle']}
                  text={data.title}
                />
                <RichText
                  dangerouslySetInnerHTML={data.description}
                  innerStyle={['roboto13Black']}
                />
                {!isMobile &&
                  <AmenitiesList
                    maxAmenities={4}
                    list={data.highlighted_amenities}
                    innerStyle={[classes.roomDescriptionMargin]}
                  />
                }
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};


const UserComments = props => {
  const { reservation, classes } = props;

  return (
    reservation.getIn(['customer', 'notes']).length > 0 && (
      <div className={classes.userNotesContainer}>
        <div className={classes.userNotes}>
          <div className={classes.userNotesTitle}>
            <RichText translate={true} text={'_%tu petición%_'} ucFirst={true} innerStyle={['roboto24Bold400Black']} />
          </div>
          <div className={classes.userNotesText}>{reservation.getIn(['customer', 'notes'])}</div>
        </div>
      </div>
    )
  );
};

const TravelClubPoints = props => {
  const { reservation, classes, hotelInfo, content, ipCountry } = props;
  //ShowTravelClub
  const ipTravelClub = ['ES', 'PT', 'AD'].includes(ipCountry);
  const travelclub =  hotelInfo.getIn(['travelclub'],false);
  const travelclubPoints = travelclub && reservation.getIn(['travelclub','points'], false);
  let travelclubText = format(content.t(
    '_%con esta reserva has conseguido los siguientes puntos en travel club: {points}.%_'),
    { points: travelclubPoints }
  );

  return (
    travelclubPoints && ipTravelClub && (
      <div className={classes.userNotesContainer}>
        <div className={classes.userNotes}>
          <div className={classes.userNotesTitle}>
            <RichText translate={true} text={'_%travelclub%_'} ucFirst={true} innerStyle={['droidSerif24Black','travelPointsTitle']} />
          </div>
          <div className={classes.userNotesText}>
            <RichText
              translate={true}
              text={travelclubText}
              ucFirst={true}
            />

          </div>

        </div>
      </div>
    )
  );
};

const PaymentAndPenalties = props => {
  const { reservation, hotelInfo, refundable, classes} = props;

  // flexmyroom | secure cancellation
  const rateSecureCancellation = reservation && reservation?.get('rates')?.some(d => d?.get('secure_cancellation', false));
  const discountSecureCancellation = reservation && reservation?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
  const serviceSecureCancellation = reservation && reservation?.get('services')?.some(d => d?.get('secure_cancellation', false));
  const pmsName = hotelInfo && hotelInfo.get('pms');
  const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;
  const customerlang = reservation && reservation.getIn(['customer', 'lang']);

  const penalties = getPenalties(reservation, hotelInfo.get("management_group_id") === PROPERTY_MANAGEMENT_GROUP, pms, customerlang, hotelInfo.get("management_group_id"));
  const isPropertyInUS = hotelInfo.get('country_iso_code', '') === "US" && hotelInfo.get("management_group_id") === PROPERTY_MANAGEMENT_GROUP;
  const isDinyaHotel = hotelInfo.get('code') === "SYN2511";

  return (
    <div className={classes.paymentAndPenaltiesContainer}>
      <div className={classes.paymentAndPenalties}>
        <div className={classes.penaltiesBox}>
          <div className={classes.penaltiesTitle}>
            <RichText
              translate={true}
              ucFirst={true}
              text={'_%política de cancelación%_'}
              innerStyle={['droidSerif24Black']}
            />
          </div>
          {pms === 'FlexMyRoom' && penalties[0].nr === true ? (
            <div className={classes.penaltiesText}>
              {penalties.map((penalty, idx) => (
                <div key={idx}>
                  <RichText
                    translate={true}
                    dangerouslySetInnerHTML={'_%flexmyroom_front_text%_'}
                    innerStyle={['roboto13Black']}
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className={classes.penaltiesText}>
              {penalties.map((penalty, idx) => (
                <div key={idx}>
                  <RichText
                    translate={true}
                    text={penalty.text}
                    withVars={penalty}
                    ucFirst={true}
                    dangerouslySetInnerHTML={true}
                  />

                </div>
              ))}
            </div>
          )}
        </div>
        {(refundable ||
          (!refundable && ['op', 'ccg', 'ccng', 'htlng'].includes(reservation.getIn(['payment', 'payform_code'])))) && (
          <div className={classes.paymentBox}>
            <div className={classes.paymentTitle}>
              <RichText translate={true} ucFirst={true} text={'_%pago%_'} innerStyle={['droidSerif24Black']} />
            </div>
            <div className={classes.paymentText}>
            {!isDinyaHotel && (
              <div>
                <RichText
                  translate={true}
                  dangerouslySetInnerHTML={payForms[reservation.getIn(['payment', 'payform_code'])]}
                  ucFirst={true}
                />
              </div>
            )}
              <div>
                <RichText dangerouslySetInnerHTML={hotelInfo.get('city_tax')} />
                {isPropertyInUS &&
                  <>
                    <br/>
                    <div>
                      <RichText dangerouslySetInnerHTML={`${hotelInfo.get('address', '')} ${hotelInfo.get('city', '')} ${hotelInfo.get('zip_code', '')}, ${hotelInfo.get('country', '')} `} /> <br/>
                      <RichText dangerouslySetInnerHTML={hotelInfo.get('phone', '')} /> <br/>
                      <RichText dangerouslySetInnerHTML={hotelInfo.get('email', '')} />
                    </div>
                  </>
                }
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const HotelInfoData = props => {
  const { fullAddress, hotelInfo } = props;
  const { classes } = props;
  const resizableImages = props.resizableImages && props.width ? props.width : '';
  return (
    <div className={classes.hotelInfoContainer}>
      <div className={classes.hotelInfoBox}>
        <div className={classes.hotelImage} ref={props.setInnerRef}>
          <Image
            innerStyle={'backgroundImageBase'}
            alt={hotelInfo.get('name')}
            backgroundImage={
              process.env.NODE_ENV === 'development'
                ? 'https://edge.media.datahc.com/HI378221428.jpg' + resizableImages
                : hotelInfo.get('default_photo') + resizableImages
            }
          />
        </div>
        <div className={classes.hotelInfo}>
          <div className={classes.hotelHeader}>
            {hotelInfo.get('total_opinions') > 0 &&
              <div className={classes.hotelOpinion}>
                <RichText
                  innerStyle={[classes.smile]}
                  icon={{
                    content: '',
                    innerStyle: ['']
                  }}>
                  {hotelInfo.get('avg_opinions')}
                </RichText>
              </div>
            }
            <div className={classes.hotelTitle}>
              <Stars innerStyle={classes.stars} config={{ stars: hotelInfo.get('stars') }} />
              <div className={classes.hotelName}>{hotelInfo.get('name')}</div>
              <div className={classes.hotelInfoAddress}>{fullAddress}</div>
            </div>
          </div>
          <div className={classes.hotelData}>
            <RichText dangerouslySetInnerHTML={hotelInfo.get('general_info')} />
          </div>
        </div>
        {/* <div className={classes.hotelMap}>
          <Image
            innerStyle={classes.mapImageConfirmation}
            backgroundImage={
              'https://maps.googleapis.com/maps/api/staticmap?' +
              'size=1280x500&' +
              'scale=2&' +
              'markers=icon:./assets/icons/gmapmarker.png|' +
              hotelLatitude +
              ',' +
              hotelLongitude +
              '&language=' +
              langCode +
              '&' +
              'style=feature:poi.business|visibility:off&' +
              'style=feature:water|color:0x66b2ff&' +
              'key=' +
              GOOGLE_MAP_API_KEY +
              '&center=' +
              hotelLatitude +
              ',' +
              hotelLongitude +
              '&zoom=16'
            }
          />
        </div>*/}
        {hotelInfo.get('how_to_arrive', false).length > 0 && (
          <div className={classes.hotelOtherInfo}>
            <div className={classes.howToArrive}>
              <div className={classes.hotelOtherInfoTitle}>
                <RichText
                  translate={true}
                  text={'_%cómo llegar%_'}
                  ucFirst={true}
                  innerStyle={['droidSerif24Black400']}
                />
              </div>
              <div className={classes.hotelOtherInfoText}>
                <RichText dangerouslySetInnerHTML={hotelInfo.get('how_to_arrive')} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Banner = props => {
  // logica
  const banners = props.hotelInfo.get('banners');
  const checkinReservation = moment(props.reservation.get('checkin'));
  const bookingReservation = moment(props.reservation.get('booking_date'));
  const { classes } = props;
  let banner = null;

  if (banners) {
    banners.forEach(function (ban) {
      let isBannerCheckin = false,
        isBannerBooking = false;
      let checkinDateStart = ban.get('checkin_date_start');
      if (checkinDateStart) {
        let checkinStartDate = moment(checkinDateStart);
        let checkinEndDate = moment(ban.get('checkin_date_end'));
        if (checkinStartDate.isSameOrBefore(checkinReservation) && checkinEndDate.isSameOrAfter(checkinReservation)) {
          isBannerCheckin = true;
        }
      }
      let bookingDateStart = ban.get('booking_date_start');
      if (bookingDateStart) {
        let bookingStartDate = moment(bookingDateStart);
        let bookingEndDate = moment(ban.get('booking_date_end'));
        if (bookingStartDate.isSameOrBefore(bookingReservation) && bookingEndDate.isSameOrAfter(bookingReservation)) {
          isBannerBooking = true;
        }
      }

      if (isBannerCheckin && isBannerBooking && (!banner || ban.weight < banner.weight)) {
        banner = ban;
      }
    });
  }
  if (banner) {
    const title = banner.get('title'),
      subtitle = banner.get('subtitle'),
      buttonText = banner.get('button_text'),
      buttonLink = banner.get('link'),
      description = banner.get('description');
    const image =
      process.env.URL_ENVIRONMENT +
      '/api/management_groups/' +
      props.hotelInfo.get('management_group_id') +
      '/medias/' +
      banner.get('media_id');
    const social = props.hotelInfo.get('socialNetworks');

    return (
      <div className={classes.flightContainer}>
        <div className={classes.flightBox}>
          <Image innerStyle={'flightBoxImage'} backgroundImage={image} alt={banner.get('title')}>
            <div className={classes.flightInfo}>
              <div>
                {social.map(function (network) {
                  return (
                    <Link
                      key={network.get('code')}
                      title={network.get('code')}
                      image={{ svg: network.get('code') }}
                      href={network.get('url') + '/' + network.get('user')}
                    />
                  );
                })}
              </div>
              <div className={classes.flightText}>
                <RichText ucFirst={true} text={title} />
              </div>
              <div className={classes.hotelTitle}>
                <RichText ucFirst={true} text={subtitle} />
              </div>
              <div className={classes.flightTitle}>
                <RichText ucFirst={true} text={description} />
              </div>
              <div className={classes.flightButton}>
                <Link
                  richText={{
                    innerStyle: ['fontSize13', 'block', 'toggleMainLinkReverse'],
                    text: buttonText
                  }}
                  innerStyle={['fontSize13', 'block', 'toggleMainLinkReverse']}
                  href={buttonLink}
                  target={'_blank'}
                />
              </div>
            </div>
          </Image>
        </div>
      </div>
    );
  } else {

    const hotelLinks = [
      '_%vuelo_mas_hotel_link%_',
      '_%activities_link%_',
      '_%transfers_link%_',
      '_%rent_link%_',
      '_%transport_link%_'
    ];

    const bannerHotelLink = pipe(map(props.content.getHasKeyAndContent), find(val => val))(hotelLinks),
    mboxScript = props.content.getHasKeyAndContent('_%mbox_script_link%_') ;
    if(bannerHotelLink && mboxScript) {
      return (
        <MBoxBanner
          hotelInfo={props.hotelInfo}
          reservation={props.reservation}
          reservationRequest={props.reservationRequest}
          langCode={props.langCode}
          urlFlyHotel={bannerHotelLink}
          mboxScript={mboxScript}/>
      )
    }else{
      return null;
    }
  }
};

class Confirmation extends React.Component {
  static displayName = 'Confirmation';

  constructor(props) {
    super(props);
    this.state = {
      width:null,
      showDescriptionRoom: true
    };
    this.widthRef = React.createRef();
    const { hotelInfo, referer } = this.props.config;
    const scripts = hotelInfo.getIn(['extended_scripts'], undefined);
    if (scripts && scripts.size > 0 && referer) {
      addScripts(hotelInfo, referer, 'confirmation');
    }
    this.props.config.triggerEvent();
  }

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  getWidthComponent = () => {
    if(this.widthRef.current){
      this.setState({
        width: this.props.theme.getDesirableWidth(this.widthRef.current.offsetWidth, this.widthRef.current.offsetHeight)
      });
    }
  }

  componentDidMount() {
    this.getWidthComponent();
  }

  render() {
    const { config, theme, content } = this.props;
    const { classes } = theme.styles;
    const {
      hotelId,
      reservation,
      hotelInfo,
      langCode,
      countries,
      refundable,
      parsedServices,
      hotelAvail,
      reservationRequest,
      showActivateTex,
      ipCountry,
      hotelConfig,
      langInfo
    } = config;


    const country = countries.find(c => c.get('alpha2') === reservation.getIn(['customer', 'country']));
    const phonePrefix = country && country.get('phone_prefix', '');
    const travelclub =  hotelInfo.getIn(['travelclub'],false);
    const travelclubPoints = travelclub && reservation.getIn(['travelclub','points'], false);
    const isEurostarsGroup = hotelInfo.get("management_group_id") === PROPERTY_MANAGEMENT_GROUP;

    const show_rooms_description = hotelConfig.get("show_rooms_description");

    const fullAddress = `${hotelInfo.get('address') || ''} ${hotelInfo.get('city') || ''} ${hotelInfo.get('zip_code') ||
      ''} ${hotelInfo.get('country') || ''}`;

    return (
      <div className={theme.computedInnerStyle}>
        <ConfirmationSimple reservation={reservation} hotelId={hotelId} phonePrefix={phonePrefix} classes={classes} />
        {showActivateTex && <LoyaltyConfirmationInfo classes={classes} webAdvantages={hotelInfo.get('web_advantages', List())} showActivateTex={showActivateTex} />}
        <Breakdown
          hotelInfo={hotelInfo}
          reservation={reservation}
          langCode={langCode}
          fullAddress={fullAddress}
          parsedServices={parsedServices}
          hotelAvail={hotelAvail}
          reservationRequest={reservationRequest}
          classes={classes}
          content={content}
          hotelConfig={hotelConfig}
          langInfo={langInfo}
        />
        {show_rooms_description &&
          <RoomsInfo
            hotelInfo={hotelInfo}
            reservation={reservation}
            langCode={langCode}
            fullAddress={fullAddress}
            parsedServices={parsedServices}
            hotelAvail={hotelAvail}
            reservationRequest={reservationRequest}
            classes={classes}
            content={content}
            hotelConfig={hotelConfig}
            langInfo={langInfo}
            theme={theme}
            isMobile={this.isMobile()}
            width={this.state.width}
          />
        }
        <PaymentAndPenalties reservation={reservation} hotelInfo={hotelInfo} refundable={refundable} classes={classes} />
        {reservation.getIn(['customer', 'notes']) && <UserComments reservation={reservation} classes={classes} />}
        {travelclubPoints && <TravelClubPoints reservation={reservation} classes={classes} hotelInfo={hotelInfo} content={content} ipCountry={ipCountry}/>}
        {reservation.get('client') && isEurostarsGroup && <CorporateBanner classes={classes} />}
        {!showActivateTex && <LoyaltyConfirmationInfo classes={classes} webAdvantages={hotelInfo.get('web_advantages', List())} showActivateTex={showActivateTex} />}
        <HotelInfoData fullAddress={fullAddress} hotelInfo={hotelInfo} langCode={langCode} classes={classes} resizableImages={theme.resizableImages} isMobile={this.props.theme.deviceType !== 'DESK'} setInnerRef={this.widthRef} width={this.state.width}/>
        <Banner hotelInfo={hotelInfo} reservation={reservation} content={content} classes={classes} langCode={langCode} reservationRequest={reservationRequest} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    triggerEvent: () => {
      dispatch(actions.events.trigger('confirmed_booking'));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const reservation = store.getIn(['customer', 'reservation']);
  const langCode = store.getIn(['customer', 'lang_info', 'code'], 'en');
  const hotelAvail = storage.get('hotel_avail')
    ? fromJS(storage.get('hotel_avail'))
    : store.getIn(['avail', hotelId, store.getIn(['hotels', hotelId, 'params', reservationAvailQuery(store).get("string_params")]), 'response']);
  const serviceAvailResponse = storage.get('service_avail')
    ? fromJS(storage.get('service_avail'))
    : store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'string_service_query_params']),
      'response'
    ]);
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  const parsedServices = parseServices(hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse, true);
  const managementGroupID = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id');
  const starTravelerRate = getLoyaltyDiscount(store);
  const logined = store.getIn(['customer', 'loyalty', 'user', 'user_id']);
  const showActivateTex = !logined && starTravelerRate ? true : false;


  return {
    hotelId: hotelId,
    reservation: reservation.size && reservation.get('status') === 'confirmed' ? reservation : undefined,
    reservationRequest: store.getIn(['customer', 'reservation_request']),
    hotelAvail: is(List, hotelAvail) && hotelAvail.size > 0 && hotelAvail,
    hotelInfo: store.getIn(['hotels', hotelId]),
    langCode: langCodeCorrector(langCode),
    countries: store.get('countries'),
    refundable: isRefundable(hotelAvail, reservationBlocks, parsedServices, serviceAvailResponse, managementGroupID, true),
    managementGroupID: managementGroupID,
    parsedServices: parsedServices,
    referer: store.getIn(['customer', 'params', 'url_params', 'id_referer'], false),
    starTravelerRate: starTravelerRate,
    showActivateTex: showActivateTex,
    ipCountry: store.getIn(['customer','country_ip'],false),
    hotelConfig : contextualizeAppConfig(store, hotelId),
    langInfo: store.getIn(['customer', 'lang_info'])
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  PropertyManager([
    'hotelId',
    'reservation',
    'hotelInfo',
    'langCode',
    'countries',
    'refundable',
    'parsedServices',
    'hotelAvail',
    'reservationRequest',
    'triggerEvent',
    'managementGroupID',
    'referer',
    'loyaltyDiscount',
    'starTravelerRate',
    'showActivateTex',
    'ipCountry',
    'hotelConfig',
    'langInfo',
  ]),
  withThemeJSS({ styleFile, index: 100, link: true }),
  withContent('i18n')
)(Confirmation);
